/**
 * Agent Form Component Types
 */

import { z } from 'zod';

/**
 * Agent Form Validation Schema with Zod
 */
export const agentFormSchema = z.object({
  organizationRef: z
    .string()
    .min(1, 'Referência da organização é obrigatória')
    .uuid('Referência da organização deve ser um UUID válido'),
  
  name: z
    .string()
    .min(1, 'Nome é obrigatório')
    .min(2, 'Nome deve ter no mínimo 2 caracteres')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  
  identifier: z
    .string()
    .max(100, 'Identificador deve ter no máximo 100 caracteres')
    .optional(),
  
  hostname: z
    .string()
    .max(255, 'Hostname deve ter no máximo 255 caracteres')
    .optional(),
  
  machineId: z
    .string()
    .max(255, 'Machine ID deve ter no máximo 255 caracteres')
    .optional(),
  
  os: z
    .string()
    .max(100, 'Sistema operacional deve ter no máximo 100 caracteres')
    .optional(),
  
  osRelease: z
    .string()
    .max(100, 'Release do SO deve ter no máximo 100 caracteres')
    .optional(),
  
  osVersion: z
    .string()
    .max(100, 'Versão do SO deve ter no máximo 100 caracteres')
    .optional(),
  
  architecture: z
    .string()
    .max(50, 'Arquitetura deve ter no máximo 50 caracteres')
    .optional(),
  
  pythonVersion: z
    .string()
    .max(50, 'Versão do Python deve ter no máximo 50 caracteres')
    .optional(),
  
  agentVersion: z
    .string()
    .max(50, 'Versão do agente deve ter no máximo 50 caracteres')
    .optional(),
  
  status: z.enum(['online', 'offline', 'inactive', 'error'], {
    errorMap: () => ({ message: 'Status inválido' }),
  }).optional(),
});

/**
 * Infer TypeScript type from schema
 */
export type AgentFormData = z.infer<typeof agentFormSchema>;

export interface AgentFormProps {
  /**
   * Initial form values for editing
   */
  initialValues?: Partial<AgentFormData>;

  /**
   * Form mode
   */
  mode: 'create' | 'edit';

  /**
   * Submit callback
   */
  onSubmit: (data: AgentFormData) => void | Promise<void>;

  /**
   * Cancel callback
   */
  onCancel: () => void;

  /**
   * Loading state
   */
  isLoading?: boolean;
}
